<template>
  <header class="page__header">
    <b-navbar toggleable="lg" fixed="top">
      <div class="flex__row flex--100">
        <router-link to="/">
          <img class="header-logo" src="../../assets/svg/logo.svg" alt="Beautynet Logo" @click="closeMobileMenu"/>
        </router-link>
      </div>

      <div v-if="isAuthenticated && !mobileMenuOpen" class="nav-items nav-items--small">
        <div class="notifications-button-wrapper">
          <badge v-if="unreadNotificationCount > 0"
                 class="notifications-button__badge"
                 colour="secondary"
                 text-colour="white"
                 size="small">
            {{ unreadNotificationCount }}
          </badge>
          <icon-button v-if="!mobileMenuOpen"
                       ref="smallNotificationButton"
                       icon="notifications"
                       class="button--header"
                       @click="notificationsClickHandler($refs.smallNotificationButton)"/>
        </div>
        <padding direction="right" size="medium"/>
        <icon-button icon="menu" class="button--header" @click="openMobileMenu"/>
      </div>

      <div v-if="isAuthenticated && mobileMenuOpen" class="nav-items nav-items--small">
        <close-button class="button--header" @click="closeMobileMenu"/>
      </div>

      <div v-if="isAuthenticated" class="nav-items nav-items--large">
        <padding v-for="name in routes" :key="name" direction="right">
          <router-link :to="routePaths[name]" class="header-link" :id="`route-nav-button-${name}`">
            <Button :colour="isCurrentRoute(name) ? 'secondary' : 'grey'"
                    :type="isCurrentRoute(name) ? 'solid' : 'text'"
                    :icon="routeIcons[name]"
                    class="button--header"
                    @click="routeClickHandler(name)">
              {{ routeLabels[name] }}
            </Button>
          </router-link>
        </padding>

        <padding direction="left" class="button--header">
          <pipe class="pipe--header" colour="secondary"/>
        </padding>

        <button-container>
          <padding direction="horizontal" size="medium-large" class="button--header">
            <icon-button ref="userButton" icon="user" class="button--header" @click="userClickHandler"/>
          </padding>
          <div class="notifications-button-wrapper">
            <badge v-if="unreadNotificationCount > 0"
                   class="notifications-button__badge"
                   colour="secondary"
                   text-colour="white"
                   size="small">
              {{ unreadNotificationCount }}
            </badge>
            <icon-button ref="largeNotificationButton"
                         icon="notifications"
                         class="button--header"
                         @click="notificationsClickHandler($refs.largeNotificationButton)"/>
          </div>
        </button-container>
      </div>

      <div v-if="!isAuthenticated">
        <router-link to="/login" class="header-link">
          <Button colour="grey" type="text" icon="user" class="button--header">
            Sign in / Register
          </Button>
        </router-link>
      </div>
    </b-navbar>
  </header>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { path } from 'ramda'
import { EventBus } from '@/eventBus'
import Badge from '@/components/Badge'
import Button from '../Buttons/Button'
import IconButton from '../Buttons/IconButton'
import ButtonContainer from '../Buttons/ButtonContainer'
import Pipe from '../Utils/Pipe'
import Padding from '../Utils/Padding'
import UserMenu from './UserMenu'
import CloseUserMenuButton from './CloseUserMenuButton'
import navMenuMixin from '../../mixins/navMenuMixin'
import CloseButton from '../Buttons/CloseButton'
import NotificationsModal from '../Notifications/NotificationsModal'
import CloseNotificationsModalButton from '../Notifications/CloseNotificationsModalButton'

export default {
  name: 'HeaderBar',
  components: { Badge, CloseButton, Padding, Pipe, ButtonContainer, IconButton, Button },
  mixins: [navMenuMixin],
  computed: {
    ...mapGetters(
      {
        unreadNotificationCount: 'notifications/unreadNotificationCount',
      },
    ),
    ...mapState(
      {
        isAuthenticated: path(['auth', 'isAuthenticated']),
        mobileMenuOpen: path(['mobileMenuOpen']),
      },
    ),
  },
  methods: {
    ...mapActions(
      {
        openLocalModal: 'localModal/open',
        openMobileMenu: 'openMobileMenu',
        closeMobileMenu: 'closeMobileMenu',
      },
    ),
    userClickHandler() {
      this.openLocalModal({
        targetElement: this.$refs.userButton.$el,
        contentComponent: UserMenu,
        maskComponent: CloseUserMenuButton,
        direction: 'down',
        width: 127,
        colour: 'grey',
      })
    },
    notificationsClickHandler(component) {
      this.openLocalModal({
        targetElement: component.$el,
        contentComponent: NotificationsModal,
        maskComponent: CloseNotificationsModalButton,
        direction: 'down',
        width: 450,
        colour: 'white',
        customClass: 'notifications-modal',
      })
    },
    routeClickHandler(name) {
      EventBus.$emit('navigationClick', name)
    },
  },
}
</script>
